import $ from 'jquery';
import _ from 'lodash';
import 'selectize';

export default {
    initMany: function (parent, names, options) {
        var selectors = [];
        _.each(names, function (name) {
            selectors.push('[name=' + name + ']');
        });
        parent.find(selectors.join(',')).selectize(options);
    },
    init: function (parent, name, options) {
        return parent.find('[name=' + name + ']:not([readonly])').selectize(options);
    },
    api: function (parent, name) {
        return parent.find('[name=' + name + ']')[0].selectize;
    }
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/selectize.js
 **/